"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SubExpression = void 0;
const expression_precedence_1 = require("../expression-precedence");
const expression_node_1 = require("../nodes/expression-node");
/**
 * A conventional expression tree has no concept of precedence since execution order is modeled explicitly. So to provide an infix-like
 * API for building, we need some mechanism to signal to the builder that a given sub-expression's precedence has been promoted.
 * The `SubExpression` node provides this mechanism by encapsulating such an expression under a pass-through node with atomic precedence.
 * This is equivalent to parenthesized expressions, where the `SubExpression` container acts as the parentheses around an expression in
 * infix notation.
 */
class SubExpression extends expression_node_1.ExpressionNode {
    constructor(subExpressionNode) {
        super();
        this[Symbol.toStringTag] = 'SubExpression';
        this.precedence = expression_precedence_1.ExpressionPrecedence.Expression;
        this.root = subExpressionNode;
    }
    get children() {
        return [this.root];
    }
    get type() {
        return this.root.type;
    }
    // eslint-disable-next-line @typescript-eslint/ban-types
    evaluate(operand) {
        return this.root.evaluate(operand);
    }
    format() {
        return `(${this.root.format()})`;
    }
    clone() {
        return new SubExpression(this.root.clone());
    }
    accept(visitor) {
        this.root.accept(visitor);
    }
}
exports.SubExpression = SubExpression;
//# sourceMappingURL=sub-expression.js.map